
export const userRequestLogout = (currentUserSession, nextUserSession) => {
    const { isAuthenticated, isUserRequestingLogOut } = currentUserSession;
    const n = nextUserSession;
    const userIsNotAuthenticated = isAuthenticated && !n.isAuthenticated;
    const userRequestLogOut = !isUserRequestingLogOut && n.isUserRequestingLogOut;
    return Boolean(userIsNotAuthenticated && userRequestLogOut);
};
